/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { IComponentProps } from "@cd2/tools"
import { Link } from "react-router-dom"
import { ExternalLink } from "../ExternalLink"
import { Button } from "@cd2/components/build/es6"
import { BaseButton } from "@cd2/components"

interface IProps extends IComponentProps<typeof Button> {
  to?: string
  external?: boolean
}

export function LinkButton({ to, ...props }: IProps) {
  const linkCss = css`
    text-decoration: none;

    & > button {
      height: 100%;
    }
  `
  if (props.disabled || !to) {
    return (
      <a css={linkCss}>
        <Button {...props} />
      </a>
    )
  }

  if (props.external) {
    return (
      <ExternalLink to={to} css={linkCss}>
        <Button {...props} />
      </ExternalLink>
    )
  }

  return (
    <Link to={to} css={linkCss}>
      <Button {...props} />
    </Link>
  )
}

interface ILinkBaseButtonProps extends IComponentProps<typeof BaseButton> {
  to?: string
  external?: boolean
}

export function LinkBaseButton({ to, ...props }: ILinkBaseButtonProps) {
  const linkCss = css`
    & > button {
      height: 100%;
    }
  `
  if (props.disabled || !to) {
    return (
      <a css={linkCss}>
        <BaseButton {...props} />
      </a>
    )
  }

  if (props.external) {
    return (
      <ExternalLink to={to} css={linkCss}>
        <BaseButton {...props} />
      </ExternalLink>
    )
  }

  return (
    <Link to={to} css={linkCss}>
      <BaseButton {...props} />
    </Link>
  )
}
